import { render, staticRenderFns } from "./CategoryIndex.vue?vue&type=template&id=607e4650&scoped=true&"
import script from "./CategoryIndex.vue?vue&type=script&lang=js&"
export * from "./CategoryIndex.vue?vue&type=script&lang=js&"
import style0 from "./CategoryIndex.vue?vue&type=style&index=0&id=607e4650&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607e4650",
  null
  
)

component.options.__file = "CategoryIndex.vue"
export default component.exports